import React from "react";
import Typography from "material-ui/Typography";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from "material-ui/Dialog";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
const ConfirmDialog = props => (
  <Dialog
    disableBackdropClick
    disableEscapeKeyDown
    maxWidth="sm"
    open={props.open}
  >
    <DialogTitle className={props.deleteSubTestChoice ? props.classes.subtitle : props.classes.title}>
      {props.title}
      <Button className={props.classes.close} onClick={props.onCancel} disabled={props.processing}>
        <Icon>clear</Icon>
      </Button>
    </DialogTitle>
    <DialogContent>
      <Typography gutterBottom className={props.classes.HighlightUserDetails}>
        {props.contentText}
      </Typography>
      <Typography className={props.classes.confirmSecondaryText}>
        {props.contentSecondaryText}
      </Typography>
    </DialogContent>
    <DialogActions>
      {props.backText && (
        <Button color="primary" onClick={props.onBack}>
          <Typography color="primary">{props.backText}</Typography>
        </Button>
      )}
      {props.okText && (
        <Button
          className={props.classes.submit}
          onClick={props.onOk}
          color="primary"
        >
          {props.okText}
        </Button>
      )}
      {props.yesText && (
        <Button
          className={props.classes.submit}
          onClick={props.onYes}
          color="primary"
          disabled={props.processing}
        >
          {props.yesText}
        </Button>
      )}
      {props.noText && (
        <Button
          className={props.classes.submit}
          onClick={props.onNo}
          color="primary"
          disabled={props.processing}
        >
          {props.noText}
        </Button>
      )}
    </DialogActions>
  </Dialog>
);
export default withStyles(styles)(ConfirmDialog);
